import { Component, OnInit,Input ,ChangeDetectorRef,ViewChild,Injectable} from '@angular/core';
import { NgbActiveModal, NgbModal, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { LanguageService, TranslationService, I18nModule } from '@spartacus/core';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { tap } from 'rxjs/operators';
import { FilterSortModel } from 'src/app/core/model/filter-sort.model';
import { NgbCalendar, NgbDate, NgbDateParserFormatter ,NgbDateStruct,NgbDateAdapter} from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, UntypedFormArray, FormsModule } from '@angular/forms';
import { NavigationExtras, Router, RouterLink } from '@angular/router';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import moment from 'moment';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { pairwise } from 'rxjs/operators';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { TenderTabNameModel } from 'src/app/core/model/tender-tab-name-model';
import { QuoteStatusModel } from 'src/app/core/model/quote-status-model';
import { TenderPricingOptionComponent } from 'src/app/shared/components/tender-pricing-option/tender-pricing-option.component';
import { TenderDetailsModalComponent } from 'src/app/shared/components/tender-details-modal/tender-details-modal.component';
import { TenderPlaceBidComponent } from 'src/app/shared/components/tender-place-bid/tender-place-bid.component';
import { TenderSelectProductsComponent } from 'src/app/shared/components/tender-select-products/tender-select-products.component';
import { Title } from '@angular/platform-browser';
import { element } from 'protractor';
import { ToastrService } from 'ngx-toastr';
import { TenderSelectProductsPlaceBidComponent } from 'src/app/shared/components/tender-select-products-place-bid/tender-select-products-place-bid.component';
import { environment } from 'src/environments/environment';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf, NgClass, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { CustomMycompanyComponent } from '../custom-mycompany/custom-mycompany.component';
/**
 * This Service handles how the date is represented in scripts i.e. ngModel.
 */
@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
	readonly DELIMITER = '-';

	fromModel(value: string | null): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	toModel(date: NgbDateStruct | null): string | null {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : null;
	}
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
	readonly DELIMITER = '/';

	parse(value: string): NgbDateStruct | null {
		if (value) {
			const date = value.split(this.DELIMITER);
			return {
				day: parseInt(date[0], 10),
				month: parseInt(date[1], 10),
				year: parseInt(date[2], 10),
			};
		}
		return null;
	}

	format(date: NgbDateStruct | null): string {
		return date ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year : '';
	}
}
@Component({
    selector: 'app-tender',
    templateUrl: './tender.component.html',
    styleUrls: ['./tender.component.scss'],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
    ],
    host: {
        '(window:resize)': 'onResize($event)'
    },
    imports: [CommonPageBreadcrumbsComponent, NgIf, NgSelectComponent, FormsModule, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgbInputDatepicker, NgClass, NgFor, InfiniteScrollDirective, RouterLink, CustomMycompanyComponent, DecimalPipe, DatePipe, I18nModule]
})

export class TenderComponent implements OnInit {
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  firstFieldEmittedValue: IDateRange;
  selectedProductType;
  selectedProduct: any;
  sampleProductName = [];
  data: any;
  hidebutton = false;
  productsList = [];
  pageSize = 5;
  currentPage = 1;
  sidebar: boolean;
  form: UntypedFormGroup = null;
  checkedform: UntypedFormGroup;
  length: number;
  checkArray: any;
  checkCommodityArray:any;
  checkedproductform: UntypedFormGroup;
  checkedcommodityform: UntypedFormGroup;
  isProductNull = true;
  productlength = 0;
  commoditylength =0;
  showClear = false;
  mobileCurrentSelection = null;
  isDisabledCheckBox = false;
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null = null;
  endDate: NgbDate | null = null;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  query: string = null;
  enableLoader: boolean = true;
  searchText = null;
  toDate: string = null;
  fromDate: string = null;
  error: string;
  date = 0;
  noData = false;
  index :any;
  clearBtn = false;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  //Title='BHP Connect - Invitation to bid';
  title: any;
  product:any;
  navigationData: string;
  activeTab = 'active';
  tenderTab= 'active';
  parameter=[];
  tenderDetailsData:any;
  tenderEntry:any;
  tender:any;
  COI: boolean =false;
  ITB: boolean= false;
  OpenNegotiation:boolean=true;
  productInfo: any;
  reachedToEnd: boolean = false;
  page = 0;
  material:any;
  loaderShow = false;
  materialList=[];
  errorMessage:any;
  isMobile: boolean = false;
  quoteStatusModel = new QuoteStatusModel();
  tenderTabNameModel= new TenderTabNameModel();
  userid: string;
  isRouteStrategyChanges = false;
  tenderListData:any;
   today=new Date();
   pricingBasis:any;
   quotationperiod:any;
   indexValue:any;
   productnames=[];
   proName:any;
   todayDate=moment.utc(this.today).local().format('DD/MM/YY HH:mm');
   tenderdata: any = [];
   selectedCommodity: any;
   commodityData: any;
   fixedImage: string = '/images/index_price.svg';
   indexImage: string = '/images/fixed_price.svg';
   currentRoute:any;
   writeAccess: boolean ;
   isCustomerEmulated:boolean;
   isPlaceBidDisabled:boolean = false;
   hour: any;
   min: any;
   expiring: string;
  lang: string;
  second: any;
  constructor(   private fb: UntypedFormBuilder,
    private calendar: NgbCalendar,private toastService: ToastrService,
    public formatter: NgbDateParserFormatter,private titleService: Title,private translation: TranslationService,private userAccountFacade: UserAccountFacade,
    public ModalService:NgbModal,private modalService: NgbModal,
    private router: Router,private customProductService: CustomProductsService, private cd: ChangeDetectorRef,
    private customloginservice:CustomLoginService,private csAgentAuthService:CsAgentAuthService,
    private languageservice:LanguageService) {
   
   this.tenderList(this.activeTab);
   this.checkedproductform = this.fb.group({
    checkArray: this.fb.array([])
  });
  this.checkedcommodityform = this.fb.group({
    checkCommodityArray:this.fb.array([])
  });
  }

  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
        }
      })
    })
    this.sidebar = true;
    this.indexValue = 0;
    this.showClear = false;
    this.clearBtn = false;
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.translation.translate('home.datePicker.nextMonth').subscribe(res => {
      this.nextMonth = res;
    });
    this.translation.translate('home.datePicker.preMonth').subscribe(res => {
      this.preMonth = res;
    });
    this.translation.translate('home.datePicker.selectMonth').subscribe(res => {
      this.selectMonth = res;
    });
    this.translation.translate('home.datePicker.selectyear').subscribe(res => {
      this.selectYear = res;
    });
    this.languageservice.getActive().subscribe(res => {
      this.lang = res;
    })
    this.translation.translate('home.quote.Expiringin').subscribe(res => {
      this.expiring = res;

    });
    
    this.translation.translate('home.quote.h').subscribe(res => {
      this.hour = res;

    });
    this.translation.translate('home.quote.m').subscribe(res => {
      this.min = res;

    });
    this.translation.translate('home.quote.s').subscribe(res => {
      this.second = res;

    });
    //this.titleService.setTitle(this.Title);
    this.onMobile(window.innerWidth);
    this.customProductService.getHomeLinkActive(false);
    
    this.translation.translate('breadcrumb.tender.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.tender.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.currentRoute = this.router.url;
    // this.customProductService.tendersearchValue$.pipe(pairwise()).subscribe(([previous, current]) =>{
    //   if(previous!=current){
    //     this.enableLoader = true;
    //     this.searchText = current;
    //     this.page=0;
    //     this.reachedToEnd = false;
    //     if(this.searchText>=3){
    //     this.tenderList(this.activeTab);
        
    //     }
    //     else if(this.searchText == 0) {
    //       this.tenderList(this.activeTab)
    //     }
    //   }
    // })
  this.userAccountFacade.get().subscribe( (data: any) => {
    if (data) {
      this.userid = data.uid;
      this.productsList = []
      this.tenderList(this.activeTab)
      this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
        this.loaderShow = true;
        if (current != null) {
          if (previous !== current) {
            this.loaderShow = true;
              this.activeTab = 'active';
              this.selectedProduct = null;
              this.selectedCommodity=[];
              this.productnames = [];
              setTimeout(() => {
                this.tenderList(this.activeTab);           
              }, 1000);    
          }
        }
      });
  }
});
  }
  ngOnDestroy(){
    localStorage.removeItem('foo') 
  }
changeTab(data):any{
  this.activeTab = data;
  this.page = 0;
  this.loaderShow= true;
  if (this.activeTab === 'active') {
    this.tenderTab = 'active'
    this.tenderListdata(this.tenderTab)
  }
  else if (this.activeTab === 'expired') {
    this.tenderDetailsData=[];
    this.tenderTab = 'expired'
    this.tenderListdata(this.tenderTab)
  }
}

tenderList(quoteStatus,commodity?,fromDate?, toDate?,materials?,searchText?){
  this.loaderShow = true;
  this.noData = false;
    if(this.startDate!= undefined && this.endDate!=undefined){
      this.fromDate = this.startDate?.year+'-'+this.checkPad(this.startDate?.month)+'-'+this.checkPad(this.startDate?.day);
      this.toDate = this.endDate?.year+'-'+this.checkPad(this.endDate?.month)+'-'+this.checkPad(this.endDate?.day);
    }else{
      this.fromDate=null;
      this.toDate=null;
    }
    if(this.userid){
      this.customProductService.getTendersData(this.page,quoteStatus,this.selectedCommodity,this.fromDate,this.toDate,this.selectedProduct,this.searchText).subscribe((data:any) => {
        this.loaderShow = false;
       //this.material=data.materialList
       this.customProductService.setConfirmtxt(data.confirmMessage);
       if(data && data.tenderslist){
       for(let tender of data?.tenderslist){
        for(let tenderEntry of tender?.tenderEntries){
          if(tenderEntry.quantityType == "FIXED_QUANTITY"){
            delete tenderEntry.maximumQuantity;
            delete tenderEntry.minimumQuantity;
          }else{
            delete tenderEntry.quantity;
          }
        }
      }
      if(data && data.materialList){
        this.materialList = data?.materialList?.reduce((unique, o) => {
         if(!unique.some(obj => obj.name === o.name)) {
           unique.push(o);
         }
         return unique;
     },[]);
     }else{
       this.materialList = [];
     }
        //this.customProductService.getTendersData().subscribe((data:any) => {  
      this.tenderDetailsData= data.tenderslist;
      this.tenderdata = data.tenderslist;
      this.commodityData=data.commodityTypes;
    
      this.modifyResponsetoCombinedList()
            
        this.cd.detectChanges();
    }
    else{
      this.toastService.show('Invitation to bids are not available')
    }
      },
      (err: any)=>{
        this.errorMessage = err;
        this.toastService.show("Sorry something went wrong, please try again!")
      });
    }
 
}
modifyResponsetoCombinedList(){
  for(let tenderdata of this.tenderDetailsData){
    tenderdata?.tenderEntries?.map((x)=>{
      this.pricingBasis=x.pricingBasis?.map( (o)=> o.description )
      this.quotationperiod=x.defaultQuotationPeriod?.description
      tenderdata.pricingBase=this.pricingBasis
      tenderdata.qp=this.quotationperiod
      for(let data of x.loadPortList){
        if(data.zplant==x.loadPort){
          x.loadPort=data.zloadPort
        }
      }
      });
      }
      for(let tenders of this.tenderDetailsData){
        if(tenders.tenderEntries?.length>1){
          var tendersListithSetInfo = tenders.tenderEntries.filter(x=>(x.set!='' && x.set!=undefined));
          if(tendersListithSetInfo?.length>0){
            var ObjectWhichContainsSetInfo= this.groupBy(tendersListithSetInfo,'set');
            var groupList=[];
            for(let item in ObjectWhichContainsSetInfo){
              var newName = ''
              var mainObject:any = {};
              var mainAvailable = false;
              var OptionalTendersWIthoutAnyMain = [];
              var childList = []
              tendersListithSetInfo.forEach(element => {
                if(item == element.set){
                  newName = newName+element.productName+' or ';
                  element.newName = newName;
                  if(element.materialOption == 'MAIN'){
                    mainAvailable = true;
                    mainObject = Object.assign(element);
                  }
                  else if(mainAvailable == false){
                    element.newName = undefined;
                    OptionalTendersWIthoutAnyMain.push(element);
                  }
                  
                  mainObject.newName = newName;
                  childList.push(element);
                }
              });
              mainObject.newName = mainObject.newName.substring(0,mainObject.newName.length-4);
              mainObject.childList = childList;
              if(mainAvailable){
                groupList.push(mainObject);
              }
              if(groupList.length>0){
                tenders.groupTenders = groupList;
              }
              else{
                tenders.groupTenders = [];
              }
              tenders.IndividualTenders = tenders.tenderEntries.filter(x=>(x.set=='' || x.set == undefined));
             
              if(OptionalTendersWIthoutAnyMain?.length>0){
                tenders.IndividualTenders = tenders.IndividualTenders.concat(OptionalTendersWIthoutAnyMain);
              }
            }
            tenders.combinedTenders=[...tenders?.groupTenders,...tenders.IndividualTenders];
          }
          else{
            tenders.IndividualTenders = tenders.tenderEntries
            tenders.combinedTenders=tenders.IndividualTenders

          }
        }
        else{
          tenders.IndividualTenders = tenders.tenderEntries
          tenders.combinedTenders=tenders.IndividualTenders
        }
      }
    }
groupBy = (arr, property) => {
  return arr.reduce((acc, cur) => {
    acc[cur[property]] = [...acc[cur[property]] || [], cur];
    return acc;
  }, {});
}
onCheckboxproductChange(e, id): void {
  this.productlength = 1;
  const checkArray: UntypedFormArray = this.checkedproductform.get(
    'checkArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkArray.push(new UntypedFormControl(e.target.value));
  } else {
    let i = 0;
    checkArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkArray.removeAt(i);
        return;
      }
      i++;
    });
    this.productlength = 0;
  }
  
  
   this.selectedProduct =  checkArray.value;
  // if (checkArray.length > 0) {
  //   this.productlength = 1;
  // }
  // this.materialList.forEach(item => {
  //   if (item.code !== id) {
  //     item.selected = false;
  //   }else{
  //     item.selected = true;
  //   }
  // });
  // if (e.target.checked) {
  //   this.selectedProduct = id;
  // } else {
  //   this.selectedProduct = null;
  //   this.productlength = 0;
  // }
}
onCheckboxCommodityChange(e, id): void {
  this.commoditylength = 1;
  const checkCommodityArray: UntypedFormArray = this.checkedcommodityform.get(
    'checkCommodityArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkCommodityArray.push(new UntypedFormControl(e.target.value));
  } 
  
  else {
    let i = 0;
    checkCommodityArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkCommodityArray.removeAt(i);
        return;
      }
      i++;
    });
    this.commoditylength = 0;
  }
  this.selectedCommodity = checkCommodityArray.value;
  // if (checkCommodityArray.length > 0) {
  //   this.commoditylength = 1;
  // }
  // this.commodityData.forEach(item => {
  //   if (item.id !== id) {
  //     item.selected = false;
  //   }else{
  //     item.selected = true;
  //   }
  // });
  // if (e.target.checked) {
  //   this.selectedCommodity = id;
  // } else {
  //   this.selectedCommodity = null;
  //   this.commoditylength = 0;
  // }
}

tenderListdata(quoteStatus,commodity?,fromDate?, toDate?,materials?,searchText?){  
  if(this.startDate!= undefined && this.endDate!=undefined){
    this.fromDate = this.startDate?.year+'-'+this.checkPad(this.startDate?.month)+'-'+this.checkPad(this.startDate?.day);
    this.toDate = this.endDate?.year+'-'+this.checkPad(this.endDate?.month)+'-'+this.checkPad(this.endDate?.day);
  }else{
    this.fromDate=null;
    this.toDate=null;
  } 
  this.selectedCommodity?.length >0|| this.fromDate||this.toDate||this.selectedProduct?.length>0||this.searchText?.length>0?
    this.showClear = true:this.showClear = false;  
    console.log('538')  
   this.customProductService.getTendersData(this.page,quoteStatus,this.selectedCommodity,this.fromDate,this.toDate,this.selectedProduct,this.searchText).subscribe((data:any) => {
    this.loaderShow=false;
    this.tenderDetailsData= data.tenderslist;
    this.tenderdata= data.tenderslist;
    if(data && data.materialList){
      this.materialList = data?.materialList?.reduce((unique, o) => {
       if(!unique.some(obj => obj.name === o.name)) {
         unique.push(o);
       }
       return unique;
   },[]);
   }else{
     this.materialList = [];
   }
    this.modifyResponsetoCombinedList();
  })
}
filterData(): void {
  this.page=0;
  this.loaderShow=true;
  this.tenderListdata(this.activeTab);
  // this.tenderList(this.activeTab,this.selectedCommodity,this.startDate,this.endDate,this.selectedProduct,this.searchText)
  //this.showClear = true;
} 


goToTenderDetail(index :any) { 
  // this.customProductService.getTendersData().subscribe((data:any) => {  
    const modalRef = this.modalService.open(TenderDetailsModalComponent, {centered: true,size: 'xl'});
    modalRef.componentInstance.code = this.tenderDetailsData[index];
    this.tenderListData=this.tenderDetailsData[index].tenderEntries;
  // },
  // err=>{
  //   console.log("err",err.message);
  // });  
}
checkPriceValidation($event){
  // tslint:disable-next-line:prefer-const
  let s = $event.target.value.split('.');
  if (s.length === 1){
    if (s[0].length >= 6) {
      $event.preventDefault();
    }
  }
}
convertDate(dateString,timezone): any {
  if (dateString) {
  return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
  }else{
    return '';
  }
}
required(index){
  this.parameter=[]
  this.tenderDetailsData[index]?.combinedTenders.map(val=>{
    if(val  && val.isRequired === undefined){
      val.checked = false
    }else if(val  && (val.isRequired === true || val.checked === true)){
      val.checked = true
      this.parameter.push(val);
    }else if(val  && (val.isRequired === false || val.checked === false)){
      val.checked = false
    }
  })
  this.parameter=[...new Map(this.parameter.map(v => [v.entryNumber, v])).values()]
}
expiryCalculate(date): string{
  if (date){
    return this.expiryCalculator(date);
  }
}
expiryCalculator(validityDate): any {
  let counterTime = '';
  validityDate = moment(validityDate);
  const eventTime1 = validityDate.format(); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
  const eventTime: any = moment(eventTime1).format('X');
  const currentTime: any = moment().format('X'); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
  const diffTime = eventTime - currentTime;
  let duration: any = moment.duration(diffTime * 1000, 'milliseconds');
  const interval = 1000;
  duration = moment.duration(duration - interval, 'milliseconds');
  const dayRem = duration.days();
  const hRem = duration.hours();
  const mRem = duration.minutes();
  const sRem = duration.seconds();

  
  if(this.lang == 'en'){
    counterTime = this.expiring;
    if (dayRem > 0) {
      counterTime = '';
    }else{
      if (hRem > 0) {
        counterTime += hRem + this.hour;
      }
      if (mRem > 0) {
        counterTime += mRem + this.min;
      }
      if(sRem > 0){
        counterTime += sRem + this.second;

      }
      if (dayRem <= 0 && hRem <= 0 && mRem <= 0 && sRem <= 0) {
        counterTime = '';
      }
    }
  }
  if(this.lang == 'zh'){
    counterTime = '';
    if (dayRem > 0) {
      counterTime = '';
    }else{
      if (hRem > 0) {
        counterTime += hRem + this.hour;
      }
      if (mRem > 0) {
        counterTime += mRem + this.min;
      }
      counterTime += this.expiring
      if (dayRem <= 0 && hRem <= 0 && mRem <= 0) {
        counterTime = '';
      }
    }
  }
  return counterTime;
}
openmodal(index :any , screen){
  this.required(index);
  let isrequiredfalse = this.tenderDetailsData[index]?.combinedTenders.filter(x=>x.isRequired==false)
  if(this.tenderDetailsData[index].combinedTenders?.length <= 1){
  //   if(this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum.length==1){
  //     const ModalRef = this.ModalService.open(TenderPricingOptionComponent,{centered: true,size:'sm'});
  //   ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
  //   ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
  //   ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
  //   ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
  // }
    // if(this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum.length>1){
    const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.screen=screen;
    ModalRef.componentInstance.tabName=this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum[0].pricingOptions;
    ModalRef.componentInstance.indexPrice = this.tenderDetailsData && this.tenderDetailsData[index].combinedTenders[0].premiumDiscount && this.tenderDetailsData[index].combinedTenders[0].premiumDiscount.value || '';    
    ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[index].combinedTenders[0].relativePrice && this.tenderDetailsData[index].combinedTenders[0].relativePrice.value || '';  
    ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
    ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
    ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
    ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
  // } 
}
  else {
    if(isrequiredfalse.length==0 || isrequiredfalse.length==undefined){
      const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.code =this.tenderDetailsData[index];
        ModalRef.componentInstance.indexDisabled=false;
        ModalRef.componentInstance.fixedDisabled=false;
        ModalRef.componentInstance.disabled=false;
      this.parameter[this.indexValue].finalQPFromDate=this.parameter[this.indexValue].finalQPFromDate;
      this.parameter[this.indexValue].finalQPToDate=this.parameter[this.indexValue].finalQPToDate;
      this.tenderDetailsData[index].combinedTenders.map(val=>{
        //val.checked = false;
        val.quantityshw = val.quantity;
        val.dischargePortshw = val.dischargePortDetails;
      })
      ModalRef.componentInstance.isQuantityUnrestricted = this.parameter[this.indexValue].isQuantityUnrestricted;
      
      if(this.tenderDetailsData[index].commodityType!='CN'){
        ModalRef.componentInstance.price = this.parameter[this.indexValue].materialFixedPrice1?this.parameter[this.indexValue].materialFixedPrice1:'';
        ModalRef.componentInstance.indexPrice = this.parameter[this.indexValue].materialIndexPrice1?this.parameter[this.indexValue].materialIndexPrice1:'';  
      }
      ModalRef.componentInstance.index =this.parameter;
     ModalRef.componentInstance.indexValue = this.indexValue;
     this.parameter[this.indexValue].priceTab=''
     if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
     ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
     }

    }
    if(isrequiredfalse.length>0){
    const ModalRef = this.ModalService.open(TenderSelectProductsComponent,{centered: true,size:'md'});
    this.tenderDetailsData[index].combinedTenders.map(val=>{
      val.checked = false;
      val.quantityshw = val.quantity;
      val.dischargePortshw = val.dischargePortDetails;
    })
    ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
    ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
    // ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
    ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
  }
}
  
}
metalOpenmodal(index :any, screen){
  this.required(index);
  let isrequiredfalse = this.tenderDetailsData[index]?.combinedTenders.filter(x=>x.isRequired==false)
   
  if(this.tenderDetailsData[index].combinedTenders?.length <= 1){
      const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.screen=screen;
      ModalRef.componentInstance.tabName=this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum[0].pricingOptions;
      ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
      ModalRef.componentInstance.price = '';
      ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
    ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
      // this.tenderDetailsData[index].tenderEntries[0].pricingOptionsEnum[0].pricingOptions=''  
  }else {
    if(isrequiredfalse.length==0 || isrequiredfalse.length==undefined){
      const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.code =this.tenderDetailsData[index];
    ModalRef.componentInstance.disabled=false;
    ModalRef.componentInstance.price = this.parameter[this.indexValue].relativePrice?this.parameter[this.indexValue].relativePrice:'';
    ModalRef.componentInstance.indexPrice =this.parameter[this.indexValue].premiumDiscount?this.parameter[this.indexValue].premiumDiscount:'';
  this.parameter[this.indexValue].finalQPFromDate=this.parameter[this.indexValue].finalQPFromDate;
  this.parameter[this.indexValue].finalQPToDate=this.parameter[this.indexValue].finalQPToDate;
  this.tenderDetailsData[index].combinedTenders.map(val=>{
    //val.checked = false;
    val.quantityshw = val.quantity;
    val.dischargePortshw = val.dischargePortDetails;
  })
  ModalRef.componentInstance.isQuantityUnrestricted = this.parameter[this.indexValue].isQuantityUnrestricted;
  ModalRef.componentInstance.index =this.parameter;
 ModalRef.componentInstance.indexValue = this.indexValue;
 this.parameter[this.indexValue].priceTab=''
 if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
 ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
}
    }
    
     if(isrequiredfalse.length>0 ){
const ModalRef = this.ModalService.open(TenderSelectProductsComponent,{centered: true,size:'md'});
    this.tenderDetailsData[index].combinedTenders.map(val=>{
      val.checked = false;
      val.quantityshw = val.quantity;
      val.dischargePortshw = val.dischargePortDetails;
    })
    ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
    // ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '0';
    ModalRef.componentInstance.price = '';
  }
    }
    
  
}
coalOpenmodal(index :any, screen){
  this.required(index);
  let isrequiredfalse = this.tenderDetailsData[index]?.combinedTenders.filter(x=>x.isRequired==false)
  if(this.tenderDetailsData[index].combinedTenders.length <= 1){
  //   if(this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum.length==1){
  //     const ModalRef = this.ModalService.open(TenderPricingOptionComponent,{centered: true,size:'sm'});
  //   ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
  //   ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
  //   ModalRef.componentInstance.quantity=this.tenderDetailsData[index].combinedTenders[0].maximumQuantity  
  //   ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
  //   ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
  // }
    // if(this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum.length>1){
    const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
    ModalRef.componentInstance.screen=screen;
    ModalRef.componentInstance.tabName=this.tenderDetailsData[index].combinedTenders[0].pricingOptionsEnum[0].pricingOptions;
    ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
    ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
    ModalRef.componentInstance.quantity=this.tenderDetailsData[index].combinedTenders[0].maximumQuantity;
    ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
    ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails; 
  // } 
}
else {
    if(isrequiredfalse.length==0 || isrequiredfalse.length==undefined){
      const ModalRef = this.modalService.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.code =this.tenderDetailsData[index];
        ModalRef.componentInstance.indexDisabled=false;
        ModalRef.componentInstance.fixedDisabled=false;
        ModalRef.componentInstance.disabled=false;
      this.parameter[this.indexValue].finalQPFromDate=this.parameter[this.indexValue].finalQPFromDate;
      this.parameter[this.indexValue].finalQPToDate=this.parameter[this.indexValue].finalQPToDate;
      this.tenderDetailsData[index].combinedTenders.map(val=>{
        //val.checked = false;
        val.quantityshw = val.quantity;
        val.dischargePortshw = val.dischargePortDetails;
      })
      ModalRef.componentInstance.isQuantityUnrestricted = this.parameter[this.indexValue].isQuantityUnrestricted;
      
      if(this.tenderDetailsData[index].commodityType!='CN'){
        ModalRef.componentInstance.price = this.parameter[this.indexValue].materialFixedPrice1?this.parameter[this.indexValue].materialFixedPrice1:'';
        ModalRef.componentInstance.indexPrice = this.parameter[this.indexValue].materialIndexPrice1?this.parameter[this.indexValue].materialIndexPrice1:'';  
      }
      ModalRef.componentInstance.index =this.parameter;
     ModalRef.componentInstance.indexValue = this.indexValue;
     this.parameter[this.indexValue].priceTab=''
     if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){
     ModalRef.componentInstance.quantity = this.parameter[this.indexValue].maximumQuantity;
     }

    }
    if(isrequiredfalse.length>0){
      const ModalRef = this.ModalService.open(TenderSelectProductsComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
      ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails;
      this.tenderDetailsData[index].combinedTenders.map(val=>{
        val.checked = false;
        val.quantityshw = val.quantity;
        val.dischargePortshw = val.dischargePortDetails;
      })
      ModalRef.componentInstance.productsInfo = this.tenderDetailsData[index];
      ModalRef.componentInstance.quantity=this.tenderDetailsData[index].combinedTenders[0].maximumQuantity  
      ModalRef.componentInstance.price = this.tenderDetailsData && this.tenderDetailsData[0].price && this.tenderDetailsData.price.value || '';
      ModalRef.componentInstance.quantityshw = this.tenderDetailsData[index].combinedTenders[0].quantity;
      ModalRef.componentInstance.dischargePortshw = this.tenderDetailsData[index].combinedTenders[0].dischargePortDetails; 
    }
    }
    
}
onScrollGrid(): any {
  if (!this.reachedToEnd){
      this.loaderShow = true;
    setTimeout(() => {
      this.loadNextDataTenderList();
    },1000);
  }
}


loadNextDataTenderList(): any {
  if (!this.reachedToEnd){
    this.page += 1;
     this.customProductService.getTendersData(this.page,this.tenderTab,this.selectedCommodity,this.fromDate,this.toDate,this.selectedProduct,this.searchText).pipe(tap()).subscribe((data:any) => {
    //  this.customProductService.getTendersData().pipe(tap(_=>console.log(_))).subscribe((data:any) => {
        this.loaderShow = false;
      if(data?.tenderslist.length){
        this.tenderDetailsData= this.tenderDetailsData.concat(data.tenderslist)
        this.modifyResponsetoCombinedList();
      }else{
        this.page =0;
        this.reachedToEnd = true;
       // this.loaderShow = false;
      }
    });
  } 
}

onResize(event){
  if (event.target.innerWidth < 768){
    this.isMobile = true
  }else{
    this.isMobile = false;
  } // window width
}
onMobile(event){
  if (event < 768){
    this.isMobile = true
  }else{
    this.isMobile = false;
  } // window width
}
onDateSelection(date: any, datepicker) {
  this.showClear = true;
  if (!this.startDate && !this.endDate) {
    this.startDate = date;
    
  } else if (
    this.startDate &&
    !this.endDate &&
    date &&
    date.after(this.startDate)
  ) {
    this.endDate = date;
    this.tenderListdata(this.activeTab);
    datepicker.close();
  } else {
    this.endDate = null;
    this.startDate = date;
  }
}
isHovered(date: NgbDate) {
  return (
    this.startDate &&
    !this.endDate &&
    this.hoveredDate &&
    date.after(this.startDate) &&
    date.before(this.hoveredDate)
  );
}

isInside(date: NgbDate) {
  return (
    this.endDate && date.after(this.startDate) && date.before(this.endDate)
  );
}

isRange(date: NgbDate) {
  return (
    date.equals(this.startDate) ||
    (this.endDate && date.equals(this.endDate)) ||
    this.isInside(date) ||
    this.isHovered(date)
  );
}
validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
  const parsed = this.formatter.parse(input);
  return parsed && this.calendar.isValid(NgbDate.from(parsed))
    ? NgbDate.from(parsed)
    : currentValue;
}

resetCalendar(datepicker) {
  this.clearFilterData();
}
checkPad(d?) {
  return d < 10 ? '0' + d.toString() : d.toString();
}
clearFilterData(): any {
  this.closebar();
  this.showClear=false
  this.startDate = null;
  this.endDate = null;
  this.selectedProduct = null;
  this.searchText = null;
  this.selectedCommodity = [];
  this.tenderList(this.activeTab);
}

toggle(data: any) {
  data.toggle();
  let element3 = document.getElementsByClassName(
    'btn btn-link ngb-dp-arrow-btn'
  );
  for (let i = 0; i < element3.length; i++) {
    let value = element3[i].getAttribute('title');
    element3[i].setAttribute('title', this.setTitle(value));
  }

  let element4 = document.getElementsByTagName(
    'ngb-datepicker-navigation-select'
  )[0].children;
  for (let i = 0; i < element4.length; i++) {
    let value = element4[i].getAttribute('title');
    element4[i].setAttribute('title', this.setTitle(value));
  }
}
setTitle(value) {
  switch (value) {
    case 'Select year':
      return this.selectYear;
    case 'Select month':
      return this.selectMonth;
    case 'Next month':
      return this.nextMonth;
    case 'Previous month':
      return this.preMonth;
    default:
      return;
  }
}

clearAllFilter(): any {
  this.startDate = null;
  this.endDate = null;
  this.showClear = false;
  this.selectedProduct = null;
  this.selectedCommodity = [];
  this.isProductNull = true;
  this.query = null;
  this.searchText = null;
  this.customProductService.getFilterInput(null);
  this.currentPage = 0;
  this.pageSize = 2;
 this.tenderList(this.activeTab);
}

isValidLetter(k): any {
  // return ( (k >= 48 && k <= 57));
  return (k = 47);
}

filtersidebar() {
  this.sidebar = false;
}
closebar() {
  this.sidebar = true;
}

omit_special_char(event): any {
  const k = event.charCode;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));;
}
onReset(event: Event): void {
  if (event !== undefined) {
    this.dateRangePicker.reset(event);
    this.dateRangePicker.toggleCalendarVisibility(false);
  }
  this.dateRangePicker.toggleCalendarVisibility(false);
  this.startDate = null;
  this.endDate = null;
  this.date = 0;
  if (!this.selectedProduct) {
    this.clearBtn = false;
  }
}
clearFilterMobile(event): void {
  this.closebar();
  this.startDate = null;
  this.endDate = null;
  this.selectedProduct = null;
  this.searchText = null;
  this.tenderList(this.activeTab);
  const checked = false;
}

clearFilter(): any {
  this.startDate = null;
  this.endDate = null;
  this.searchText = null;
  this.selectedProduct = null;
  this.selectedCommodity = [];
}
clear(): void {
  this.checkedproductform = this.fb.group({
    checkArray: this.fb.array([])
  });
  this.checkedcommodityform = this.fb.group({
    checkCommodityArray:this.fb.array([])
  })
  this.productlength = 0;
  this.startDate = null;
  this.endDate = null;
  this.date = 0;
  this.closebar();
  this.length = this.productlength + this.date;
  this.productsList.forEach(item => {
    item.selected = false;
  });
}
search(): void {
  this.searchText.toLowerCase();
  if (this.searchText?.length>=3) {
    this.tenderListdata(this.activeTab,this.selectedCommodity,this.startDate,this.endDate,this.selectedProduct,this.searchText)
  } else if(this.searchText.length == 0) {
    this.tenderListdata(this.activeTab,this.selectedCommodity,this.startDate,this.endDate,this.selectedProduct,'')
  
}
  this.customProductService.gettendersearchValue(this.searchText);
}
onRangeSelectedMobile(value: IDateRange): void {
  this.firstFieldEmittedValue = value;
  this.startDate = this.dateFormatToddmmyyyy(
    this.firstFieldEmittedValue.start.toString()
  );
  this.endDate = this.dateFormatToddmmyyyy(
    this.firstFieldEmittedValue.end.toString()
  );
  this.date = 1;
}
onRangeSelected(value: IDateRange): void {
  this.firstFieldEmittedValue = value;
  this.startDate = this.dateFormatToddmmyyyy(
    this.firstFieldEmittedValue.start.toString()
  );
  this.endDate = this.dateFormatToddmmyyyy(
    this.firstFieldEmittedValue.end.toString()
  );
  this.date = 1;
}
dateFormatToddmmyyyy(str): any {
  // tslint:disable-next-line:one-variable-per-declaration
  const date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join('-');
}
getResults(): void {
  this.closebar();
  this.filterData();
}
}
